import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LANGUAGE_PREFIXES = ["se", "en"];

interface BreadCrumbsProps {
    currentName?: string; // ← nytt prop
}

export const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ currentName }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const segments = location.pathname
        .split("/")
        .map((s) => s.trim())
        .filter((s) => s.length > 0 && !LANGUAGE_PREFIXES.includes(s));

    const items = [
        { label: "Hem", path: "/" },
        ...segments.map((segment, index) => ({
            label: segment
                .replace(/-/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase()),
            path: "/" + segments.slice(0, index + 1).join("/"),
        })),
    ];

    // Överskriv sista steget om currentName finns
    if (currentName) {
        items[items.length - 1].label = currentName;
    }

    return (
        <nav aria-label="Breadcrumb" className="flex items-center text-sm text-slate-500 breadcrumbs">
            {items.map((item, index) => {
                const isLast = index === items.length - 1;

                return (
                    <span key={item.path} className="inline-flex items-center whitespace-nowrap">
                        {!isLast ? (
                            <a
                                onClick={() => navigate(item.path)}
                                className="text-orange-600 hover:text-orange-700 cursor-pointer transition-colors"
                            >
                                {item.label}
                            </a>
                        ) : (
                            <span className="text-slate-500 font-medium">{item.label}</span>
                        )}

                        {!isLast && <span className="mx-3 text-slate-400 select-none separator">›</span>}
                    </span>
                );
            })}
        </nav>
    );
};